import React, {useEffect, useState} from 'react';
import {Button, Form, Modal, Select} from "semantic-ui-react";
import {useForm} from "react-hook-form";
import {fetchCourseCategories, postCourses} from "../../../../redux/actions";

const token = sessionStorage.getItem('Token')

export const CourseForm = ({show, onCancel, onSuccess}) => {

    const [categories, setCategories] = useState([]);
    const {register, handleSubmit, setValue, formState} = useForm({
        defaultValues: {
            course_category_id: '',
            name: '',
            description: '',
            support_email: '',
        }
    });

    React.useEffect(() => {
        register('course_category_id');
    }, [register])


    useEffect(() => {
        async function getData() {
            try {
                const res = await fetchCourseCategories({active: 1, product: 0});
                const options = res.data
                    .map(function (row) {
                        return {
                            key: row.id,
                            text: row.name,
                            value: row.id,
                        };
                    });
                setCategories(options);
            } catch (e) {
                console.log(e);
            }
        }

        // noinspection JSIgnoredPromiseFromCall
        getData();
    }, [token]);

    const onSubmit = async data => {

        try {
            const res = await postCourses(data);

            onSuccess(res.data);
        } catch (e) {
            alert('error')
        }
    };

    return (
        <Modal open={show} size={'tiny'}>
            <Modal.Header>Criar curso</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Form id={'form'} onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
                        <Form.Field>
                            <label>Categoria</label>
                            {/*<Controller*/}
                            {/*    as={<Select/>}*/}
                            {/*    name="course_category_id"*/}
                            {/*    // placeholder='Selecione uma Categoria'*/}
                            {/*    options={categories}*/}
                            {/*    // selectOnBlur={false}*/}
                            {/*    // clearable*/}
                            {/*    control={control}*/}
                            {/*    defaultValue={2}*/}
                            {/*    // rules={{ required: true }}*/}
                            {/*    // defaultValue={''}*/}
                            {/*    // render={props => <Checkbox {...props} />}*/}
                            {/*/>*/}
                            <Select
                                name={'course_category_id'}
                                placeholder='Selecione uma Categoria'
                                options={categories}
                                selectOnBlur={false}
                                clearable
                                onChange={(e, {value}) => {
                                    setValue('course_category_id', value);
                                }}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Nome</label>
                            <input
                                name={'name'}
                                ref={register({required: true})}
                                autoFocus
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Descrição</label>
                            <textarea
                                name={'description'}
                                ref={register({required: true})}
                                rows={2}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>E-mail para suporte</label>
                            <input
                                name={'support_email'}
                                ref={register({required: true})}
                            />
                        </Form.Field>
                    </Form>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button basic content={'Cancelar'} onClick={onCancel}/>
                <Button
                    positive
                    content="Salvar"
                    form={'form'}
                />
            </Modal.Actions>
        </Modal>
    )
}